
// Formats a URL to ensure it has the proper protocol
export const formatSocialUrl = (url: string | null): string | null => {
  if (!url) return null;
  
  // Check if URL already has protocol
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Add https protocol if missing
  return `https://${url}`;
};

// Format page URL for display - extract pathname for better readability
export const formatPageUrl = (url: string | null): string => {
  if (!url) return 'Not available';
  try {
    const urlObj = new URL(url);
    return urlObj.pathname === '/' ? urlObj.hostname : urlObj.pathname;
  } catch (e) {
    return url || 'Not available';
  }
};

// Create company initials from name
export const getCompanyInitials = (companyName: string | null): string => {
  return companyName
    ?.split(' ')
    .map(name => name[0])
    .join('')
    .toUpperCase() || '??';
};
